<app-page-breadcrumb [pageInfo]="{title : staffData?.name + ' Info'}" />
<tab-head [tabSegment]="segment" [initial]="'BASIC'">
    <ng-template #tabBody let-active="activeKey" let-visited="visited">
        <div [hidden]="active != 'ALLOTMENT'">
            <span class="text-primary m-2" *ngIf="staffData?.id"> {{staffData?.name}} Sponsor Details</span>
            <app-sponsorship-allotment-ref-list *ngIf="visited.ALLOTMENT && staffData?.id" [ref_id]="staffData?.id"
                show="ACTIVE" />
            <span class="text-primary m-2" *ngIf="spouseDetail?.id"> {{spouseDetail?.name}} Sponsor
                Details</span>
            <app-sponsorship-allotment-ref-list *ngIf="visited.ALLOTMENT && spouseDetail?.id"
                [ref_id]="spouseDetail?.id" show="ACTIVE" />
        </div>

        <div [hidden]="active != 'BASIC'">
            <div class="row text-center">
                <profile-widget [profileData]="staffData" [widgetType]="'HORIZONTAL'" />
                <ng-container *ngIf="!loadingData && !isDeleted">
                    <info-view [sourceData]="staffData" [mapData]="showData" />
                </ng-container>
                <div class="col-12" *ngIf="spouseDetail.staff_emp_id && !isDeleted">

                    <profile-widget *ngIf="spouseDetail.staff_emp_id && !isDeleted" [widgetType]="'HORIZONTAL'" [profileData]="spouseDetail" />
                    <info-view [sourceData]="spouseDetail" [mapData]="spouseInfoView" />
                </div>
                <!-- <div class="col-lg-4 col-md-12 col-xl-4" >
                </div> -->
                <!-- <div class="col-lg-8 col-md-8 col-xl-8" >
                    <div class="row pt-5 ">
                        <info-view [sourceData]="staffData" [mapData]="showData" />
                    </div>

                    <div class="row pt-5 " *ngIf="spouseDetail.staff_emp_id && !isDeleted">
                        <info-view [sourceData]="spouseDetail" [mapData]="spouseInfoView" />
                    </div>
                </div> -->
                <!-- </ng-container> -->
            </div>
        </div>
        <div [hidden]="active != 'PAYROLL'">
            <ng-container *ngIf="staffData?.id">
                <app-payroll-setting [type]="'VIEW'" [sourceData]="payrollData || staffData" />
            </ng-container>
        </div>
    </ng-template>
</tab-head>
<app-page-loader [loading]="loadingData" />